import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import LostBuyBoxEvolutionChartToolbar from "./toolbar"
import { useMarketplacesLostBuyBoxEvolutionData} from "./@hooks"


export default function LostBuyBoxEvolutionChart() {

    const { 
        dataEvolution, 
        dataEvolutionKeys, 
        dataEvolutionColors,
        isLoadingDataEvolution, 
        skuName,
        dateRange,
        onChange,
        resetEvolutionData,
    } = useMarketplacesLostBuyBoxEvolutionData()

	if (!dataEvolution?.length || isLoadingDataEvolution) return <></>

    return <ModalSeeker 
        hideActions 
        isOpen={!!dataEvolution?.length} 
        title={`Buy Box Evolution - ${skuName}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box id='evolution-chart'></Box>}
            pdfProps={{
                titlePDF:`Buy Box Evolution - ${skuName}`
            }}
            series={dataEvolutionKeys.map(key => ({
                name: key, 
                yField: key,
                xField: "date",
                connect: true,
                color: dataEvolutionColors[key],
                strokes: {
                    strokeDasharray: [0, 100000]
                },
                bullets: { 
                    hidden: false, 
                    radius: 20
                },
                tooltip: {
                    labelText: "[bold]{name}[/]"
                },
            }))}
            chartProps={{
                legend: { hidden: true },
                numberFormat: `#`,
                dateFormatReceived: 'yyyy-MM-dd',
                showBullets: true,
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    hiddenGrid: true,
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                },
                yAxis: {
                    hiddenLabels: true,
                    hiddenGrid: true
                }
            }}
            cardProps={{ actions: 
                <LostBuyBoxEvolutionChartToolbar dateRange={dateRange} onChange={onChange} />
            }}
            sx={{ height: 300 }}
        />
    </ModalSeeker>
}